declare const mobileBiometricType: string | undefined;

const MobileAppService = {
  // If the user has the ability to use biometric login
  hasBiometric: (): boolean =>
    typeof mobileBiometricType !== 'undefined' &&
    mobileBiometricType !== 'none',

  changeMetaViewport: () => {
    const metaViewport = document.querySelector('meta[name="viewport"]');
    if (MobileAppService.hasBiometric()) {
      metaViewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1',
      );
    } else {
      metaViewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1',
      );
    }
  },
};

MobileAppService.changeMetaViewport();
